import { render, staticRenderFns } from "./trialNotes.vue?vue&type=template&id=f88ace3c&"
import script from "./trialNotes.vue?vue&type=script&lang=js&"
export * from "./trialNotes.vue?vue&type=script&lang=js&"
import style0 from "./trialNotes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports